import { render, staticRenderFns } from "./CreateBranches.vue?vue&type=template&id=06f83af1&"
import script from "./CreateBranches.vue?vue&type=script&lang=js&"
export * from "./CreateBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports